(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab"] && !Shopify.designMode) return;
  try {
    
  // Robust slider JS for real mobile devices

  const tabs = Array.from(document.querySelectorAll('.tabs'));
  const wrapper = document.querySelector('.tabs-wrapper');
  const topSection = document.getElementById('topSection');
  const topTitle = document.getElementById('topTitle');
  const topDescription = document.getElementById('topDescription');
  const topButton = document.querySelector('.btn-explore');
  const sliderNav = document.querySelector('.slider-nav');

  if (!wrapper || tabs.length === 0) {
    // Nothing to do
    console.warn('Slider: wrapper or tabs missing');
  } else {
    // Dynamic slide amount: one viewport width on mobile, fixed on desktop
    function getSlideAmount() {
      return window.innerWidth < 990 ? wrapper.clientWidth : 320;
    }

    // Show or hide navigation arrows based on screen width and tab count
    function toggleArrowsVisibility() {
      const isDesktop = window.innerWidth >= 990;
      if (!sliderNav) return;
      if (isDesktop) {
        sliderNav.style.display = tabs.length > 3 ? 'flex' : 'none';
      } else {
        sliderNav.style.display = 'flex';
      }
    }

    // Activate a tab and update the top section with tab-specific content
    function activateTab(tab) {
      tabs.forEach((t) => t.classList.remove('active'));
      tab.classList.add('active');

      const content = {
        title: tab.getAttribute('data-title'),
        description: tab.getAttribute('data-description'),
        buttonText: tab.getAttribute('data-button-text'),
        buttonUrl: tab.getAttribute('data-button-url'),
        buttonRedirect: tab.getAttribute('data-button-redirect'),
        backgroundImage: tab.getAttribute('data-background-image'),
      };

      if (topSection)
        topSection.style.backgroundImage = content.backgroundImage ? `url('${content.backgroundImage}')` : '';
      if (topTitle) topTitle.textContent = content.title || '';
      if (topDescription) topDescription.textContent = content.description || '';
      if (topButton) {
        topButton.textContent = content.buttonText || '';
        topButton.href = content.buttonUrl || '#';
        topButton.target = content.buttonRedirect === 'true' ? '_blank' : '';
      }
    }

    // Find the tab that is currently closest to center (used for clicks)
    function getCenteredTab() {
      let closest = null;
      let smallestDistance = Infinity;
      const wrapperRect = wrapper.getBoundingClientRect();
      const wrapperCenter = wrapperRect.left + wrapperRect.width / 2;

      tabs.forEach((tab) => {
        const rect = tab.getBoundingClientRect();
        const tabCenter = rect.left + rect.width / 2;
        const distance = Math.abs(wrapperCenter - tabCenter);
        if (distance < smallestDistance) {
          smallestDistance = distance;
          closest = tab;
        }
      });

      return closest;
    }

    // Compute scrollLeft such that `tab` is centered in wrapper
    function computeScrollForTab(tab) {
      const tabRect = tab.getBoundingClientRect();
      const wrapperRect = wrapper.getBoundingClientRect();
      const currentScroll = wrapper.scrollLeft;
      // tab center relative to wrapper's left (in page coordinates): tabRect.left - wrapperRect.left
      const tabCenterRelative = tabRect.left - wrapperRect.left + tabRect.width / 2;
      const targetScrollLeft = currentScroll + tabCenterRelative - wrapperRect.width / 2;
      return Math.max(0, Math.round(targetScrollLeft));
    }

    // Programmatic scroll controller with detection of actual scroll end
    let programmaticScrollToken = 0;

    function scrollToPosition(targetLeft) {
      // Increase token so any previous watcher stops reacting
      const token = ++programmaticScrollToken;
      // Temporarily disable native scroll-snap to avoid conflict
      const prevSnap = wrapper.style.scrollSnapType || '';
      wrapper.style.scrollSnapType = 'none';
      // Prevent pointer interactions while scrolling programmatically
      wrapper.style.pointerEvents = 'none';

      // Use scrollTo with smooth behavior
      wrapper.scrollTo({ left: targetLeft, behavior: 'smooth' });

      return new Promise((resolve) => {
        // Watch until scrolling stops (either user or programmatic)
        let lastLeft = wrapper.scrollLeft;
        let stableCount = 0;
        const check = () => {
          // If another programmatic scroll started, abort
          if (token !== programmaticScrollToken) return resolve(false);

          const currentLeft = wrapper.scrollLeft;
          if (Math.abs(currentLeft - lastLeft) < 1) {
            stableCount++;
          } else {
            stableCount = 0;
          }
          lastLeft = currentLeft;

          // Consider scroll finished when left stable for 4 consecutive checks (~200ms)
          if (stableCount >= 4) {
            // restore
            wrapper.style.scrollSnapType = prevSnap;
            wrapper.style.pointerEvents = '';
            resolve(true);
          } else {
            // continue checking
            requestAnimationFrame(check);
          }
        };

        // Start checking on next frame
        requestAnimationFrame(check);

        // Safety fallback: after 1500ms, restore and resolve
        setTimeout(() => {
          wrapper.style.scrollSnapType = prevSnap;
          wrapper.style.pointerEvents = '';
          resolve(true);
        }, 1500);
      });
    }

    // Scroll wrapper by amount (left positive -> right)
    async function scrollWrapper(amount) {
      // choose a target scroll position based on current centered tab + amount
      const currentCentered = getCenteredTab();
      let targetTab = null;

      if (!currentCentered) {
        // fallback to first tab
        targetTab = tabs[0];
      } else if (amount > 0) {
        // move to next tab if exists
        const idx = tabs.indexOf(currentCentered);
        targetTab = tabs[Math.min(tabs.length - 1, idx + 1)];
      } else if (amount < 0) {
        const idx = tabs.indexOf(currentCentered);
        targetTab = tabs[Math.max(0, idx - 1)];
      } else {
        targetTab = currentCentered;
      }

      if (!targetTab) return;

      const targetLeft = computeScrollForTab(targetTab);

      // perform programmatic scroll and wait until it finishes
      await scrollToPosition(targetLeft);

      // finally, activate the tab we landed on (recompute centered to be safe)
      const landed = getCenteredTab() || targetTab;
      activateTab(landed);
    }

    // direct click on a tab: center that tab
    async function onTabClick(tab) {
      const targetLeft = computeScrollForTab(tab);
      await scrollToPosition(targetLeft);
      activateTab(tab);
    }

    // Initialization
    function init() {
      toggleArrowsVisibility();

      // initial active tab
      if (!document.querySelector('.tabs.active') && tabs.length > 0) {
        activateTab(tabs[0]);
        // center first tab on mobile if desired
        const target = tabs[0];
        const left = computeScrollForTab(target);
        wrapper.scrollLeft = left;
      }

      // events
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => onTabClick(tab));
      });

      const prevBtn = document.getElementById('slidePrev');
      const nextBtn = document.getElementById('slideNext');
      if (prevBtn) prevBtn.addEventListener('click', () => scrollWrapper(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => scrollWrapper(1));

      // update arrows when resizing
      window.addEventListener('resize', () => {
        toggleArrowsVisibility();
      });

      // Optional: when the user manually scrolls and stops, update active tab
      let userScrollTimeout = null;
      wrapper.addEventListener('scroll', () => {
        if (programmaticScrollToken > 0) {
          // If there was a recent programmatic scroll, ignore the first user scroll events
        }
        clearTimeout(userScrollTimeout);
        userScrollTimeout = setTimeout(() => {
          const centered = getCenteredTab();
          if (centered) activateTab(centered);
        }, 150);
      });
    }

    // Run
    init();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinite-scroll-slider"] && !Shopify.designMode) return;
  try {
    
  var copy = document.querySelector('.logo-slider .logos-slide').cloneNode(true);
  document.querySelector('.logo-slider .logo-slider').appendChild(copy);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-scroll"] && !Shopify.designMode) return;
  try {
    
  const timelineData = JSON.parse(document.getElementById('timeline-data').textContent);
  let activeIndex = window.innerWidth <= 750 ? 0 : 2; // Mobile: start at 0, Desktop: start at 2
  let wasMobile = window.innerWidth <= 750; // Track mobile/desktop state

  function updateTimelineLineWidth() {
    const timelineItems = document.getElementById('timelineItems');
    const timelineLine = document.querySelector('.timeline-line');
    if (timelineItems && timelineLine) {
      // Set the timeline line width to the scroll width of timeline items container
      timelineLine.style.width = timelineItems.scrollWidth + 'px';
    }
  }

  function initTimeline() {
    const timelineItems = document.getElementById('timelineItems');

    // Clear timelineItems and insert timeline-line first
    timelineItems.innerHTML = '<div class="timeline-line"></div>';

    timelineData.forEach((item, index) => {
      const timelineItem = document.createElement('div');
      timelineItem.className = 'timeline-item';
      timelineItem.innerHTML = `
        <div class="timeline-dot"></div>
        <div class="timeline-year">${item.year}</div>
      `;
      timelineItem.addEventListener('click', () => setActive(index, true));
      timelineItems.appendChild(timelineItem);
    });

    updateTimelineLineWidth();
    setActive(activeIndex, false);
  }

  function updateButtons() {
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');

    prevBtn.disabled = activeIndex === 0;
    nextBtn.disabled = activeIndex === timelineData.length - 1;
  }

  function setActive(index, smoothScroll = false) {
    if (index < 0 || index >= timelineData.length) return;
    const items = document.querySelectorAll('.timeline-item');
    const content = document.getElementById('timelineContent');
    const title = document.getElementById('contentTitle');
    const description = document.getElementById('contentDescription');
    const image = document.getElementById('image-content');

    items.forEach((item) => item.classList.remove('active'));
    items[index].classList.add('active');

    content.classList.remove('show');
    setTimeout(() => {
      title.textContent = timelineData[index].title;
      description.innerHTML = timelineData[index].text;
      image.src = timelineData[index].image;
      image.alt = timelineData[index].title;
      content.classList.add('show');
    }, 200);

    if (smoothScroll) {
      items[index].scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }

    activeIndex = index;
    updateButtons();
  }

  document.addEventListener('DOMContentLoaded', () => {
    initTimeline();
    updateButtons();

    document.getElementById('prevBtn').addEventListener('click', () => {
      if (activeIndex > 0) {
        setActive(activeIndex - 1, true);
      }
    });

    document.getElementById('nextBtn').addEventListener('click', () => {
      if (activeIndex < timelineData.length - 1) {
        setActive(activeIndex + 1, true);
      }
    });

    // Fixed resize behavior
    window.addEventListener('resize', () => {
      updateTimelineLineWidth();

      const isMobile = window.innerWidth <= 750;
      // Only reset when switching between mobile ↔ desktop
      if (isMobile !== wasMobile) {
        activeIndex = isMobile ? 0 : 2;
        setActive(activeIndex, true);
      }
      wasMobile = isMobile;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
